import React from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/theme/ThemeProvider";

// Three-way theme switch (light / dark / system). Never colour alone: each has
// an icon + accessible label.
export default function ThemeSwitch() {
  const { theme, setTheme } = useTheme();
  const opts = [
    { v: "light", label: "Light", Icon: Sun },
    { v: "dark", label: "Dark", Icon: Moon },
    { v: "system", label: "System", Icon: Monitor },
  ];
  return (
    <div className="segmented" role="radiogroup" aria-label="Theme">
      {opts.map(({ v, label, Icon }) => (
        <button
          key={v}
          role="radio"
          aria-checked={theme === v}
          aria-label={label}
          title={label}
          className={theme === v ? "active" : ""}
          data-testid={`theme-${v}`}
          onClick={() => setTheme(v)}
        >
          <Icon size={20} strokeWidth={1.75} aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
